import React from 'react';
import { BarChart as Chart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

import { CircularProgress } from '../Styles';

import { Theme } from '../Styles';

const getTimeRange = (date, unit) => {
	let startDate = '';
	let endDate = '';
	let year, month, week, day;

	switch (unit) {
		case 'day':
			[year, month, day] = date.split('-');
			year = parseInt(year, 10);
			month = parseInt(month, 10);
			day = parseInt(day, 10);

			startDate = new Date(year, month - 1, day);
			startDate.setDate(startDate.getDate() - 1);
			endDate = new Date(year, month - 1, day);

			break;
		case 'week':
			[year, week] = date.split('-');
			year = parseInt(year, 10);
			week = parseInt(week, 10);
			day = 1 + (week - 1) * 7;

			startDate = new Date(year, 0, day);
			startDate.setDate(startDate.getDate() - 7);
			endDate = new Date(year, 0, day);

			break;
		case 'month':
			[year, month] = date.split('-');
			year = parseInt(year, 10);
			month = parseInt(month, 10);
			day = new Date().getDate();

			startDate = new Date(year, month, day);
			startDate.setMonth(startDate.getMonth() - 1);
			endDate = new Date(year, month, day);

			break;
		default:
			break;
	}

	startDate = startDate.getTime();
	endDate = endDate.getTime();

	return { startDate, endDate };
};

class BarChart extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {};
	}

	formatYAxis = (tick) => {
		let tickNumber = Number(tick);
		if (tickNumber >= 1000) {
			tick = tickNumber / 1000 + 'K    ';
		}
		return tick;
	};

	render() {
		let { data, unit, enableRedirect } = this.props;

		if (data && data.length) {
			data = data.map((data, index) => {
				const { startDate, endDate } = getTimeRange(data._id, unit);
				data.redirect = `/ordersV2?start_date=${startDate}&end_date=${endDate}`;
				return data;
			});
		}

		return (
			<ResponsiveContainer
				width='100%'
				minHeight='450px'
			>
				{data && data.length ? (
					<Chart
						data={data}
						onClick={(data) => {
							if (data && data.activePayload && data.activePayload.length > 0) {
								if (!enableRedirect && data.activePayload[0].payload && data.activePayload[0].payload.redirect) {
									window.location.assign(data.activePayload[0].payload.redirect);
								}
							}
						}}
					>
						<XAxis
							dataKey='_id'
							angle={-35}
							textAnchor='end'
							height={80}
						/>
						<YAxis
							dx={-20}
							tickFormatter={this.formatYAxis}
						/>
						<Tooltip />
						<Bar
							barSize={30}
							dataKey='Total Orders'
							fill={Theme.primary}
							radius={[5, 5, 0, 0]}
						/>
					</Chart>
				) : (
					<div style={{ alignSelf: 'center', marginTop: '3rem' }}>
						<CircularProgress showSpinner={true} />
					</div>
				)}
			</ResponsiveContainer>
		);
	}
}

export default BarChart;
